import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray, ValidatorFn, AbstractControl
} from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { User } from "../../models/user";
import { Project } from "../../../project/models/project";
import { UserGroup } from "../../models/user-group";
import {FormValidationService} from "../../../../shared/services/form-validation.service";

@Component({
  selector: "app-user-edit",
  template: require('./user-edit.component.html'),
  styles: [require('./user-edit.component.sass')]
})
export class UserEditComponent implements OnInit {
  @ViewChild("userEditModal") userEditModal: ElementRef;

  @Input() projectUserGroups: {
    project: Project;
    userGroups: UserGroup[];
  }[];

  @Output() saveUser = new EventEmitter<User>();

  user: User | undefined;
  userForm: FormGroup;
  userEditModalReference: NgbModalRef;

  isSelected = false;

  selectableProjectUserGroups: any[];

  get userAccessFormArray() {
    return this.userForm.controls.userAccess as FormArray;
  }

  constructor(private fb: FormBuilder, private modalService: NgbModal,  public formValidation:FormValidationService) {
    this.userForm = this.fb.group({
      name: ["", Validators.required],
      username: ["", Validators.required],
      email: [
        "",
        [
          Validators.compose([
            Validators.required,
            Validators.email,
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
          ])
        ]
      ],
      admin: [""],
      integratedConsole: [""],
      firstlogin: [""],
      userAccess: new FormArray([])
    });
  }

  ngOnInit(): void {
    this.selectableProjectUserGroups = this.projectUserGroups.filter(userGroup => userGroup.project.id > 0);
    this.selectableProjectUserGroups
      .forEach(project =>
        this.userAccessFormArray.push(
          new FormGroup({
            project: new FormControl(false),
            groups: new FormControl([])
          })
        )
      );
      this.isSelected = false
  }

  async showModal(user?: User) {
    this.userForm.get("username")?.enable({ onlySelf: true });
    this.userForm.reset();
    this.user = user;
    if (this.user && this.user.id) {
      this.userForm.get("username")?.disable({ onlySelf: true });
      const userData = {
        name: this.user.name,
        username: this.user.username,
        email: this.user.email,
        admin: this.user.admin,
        integratedConsole: this.user.userProjects && !!this.user.userProjects.find(project => project.projectId === 0),
        firstlogin: this.user.firstlogin,
        userAccess: this.selectableProjectUserGroups
          .map(projectUserGroup => {
            return {
              project:
                this.user &&
                this.user.userProjects &&
                this.user.userProjects.find(
                  userProject =>
                    userProject.projectId === projectUserGroup.project.id
                ),
              groups:
                this.user &&
                this.user.userGroups &&
                this.user.userGroups
                  .filter(
                    group => group.projectId === projectUserGroup.project.id
                  )
                  .map(group =>
                    projectUserGroup.userGroups.find(
                      userGroup => userGroup.name === group.name
                    )
                  )
            };
          })
      };
      this.userForm.patchValue(userData);
    } else {
      this.userForm.get("firstlogin")?.setValue(true);
    }

    this.userEditModalReference = await this.modalService.open(
      this.userEditModal,
      {
        size: "xl",
        backdrop: "static"
      }
    );
  }

  userAccessValidation(){
    if(this.userForm.controls['userAccess'].value.map(projectUserGroup => {
      return projectUserGroup})
        .filter(userAccess => !!userAccess.project)
        .filter(group => !!group.groups).length == 0 && !this.userForm.value.admin){
      return true
    }
    else{
      return false
    }
  }

  save() {
    this.isSelected = true
    let user: User
    if (!this.userAccessValidation() && this.userForm.valid) {
      user = {
       id: this.user ? this.user.id : undefined,
       ...this.user,
       username:
         (this.user && this.user.username) || this.userForm.value.username,
       name: this.userForm.value.name,
       email: this.userForm.value.email,
       admin: !!this.userForm.value.admin,
       firstlogin: this.userForm.value.firstlogin
     };
     if (!this.userForm.value.admin) {
       const userProjects =  this.projectUserGroups
                             .filter(projectUserGroup => {
                               if (projectUserGroup.project.id === 0) {
                                 return this.userForm.value.integratedConsole;
                               } else {
                                 return !!this.userForm.value.userAccess.find(userAccess => userAccess.project && userAccess.groups.find(group => group.projectId === projectUserGroup.project.id))
                               }
                             })
                             .map(projectUserGroup => {
                               return {
                                 projectId: projectUserGroup.project.id
                               };
                             })
       const userGroups = this.userForm.value.userAccess
                       .filter(userAccess => !!userAccess.project)
                       .reduce((all, userAccess) => {
                         return [...all, ...userAccess.groups];
                       }, [])
       user = {
         ...user,
         userProjects,
         userGroups
       }
     }
     this.saveUser.emit({ ...user });
     this.userEditModalReference.close();
   }
    else {
      this.formValidation.validateAllFormFields(this.userForm);
    }
  }

  cancel(){
      this.isSelected = false
     this.userEditModalReference.dismiss();
  }
}
